import { createUrlFilterStore } from "#/stores/url-filter-store";

/**
 * Filter store for multiple book IDs (e.g., ?book_id=1&book_id=2)
 */
export const bookIdFilterSignal = createUrlFilterStore<number[]>({
  param: "book_id",
  defaultValue: [],
  multi: true,
  serialize: (ids: number[]) => ids.map((id: number) => id.toString()),
  deserialize: (value: string | string[]) => {
    const strs = Array.isArray(value) ? value : [value];
    return strs.map(Number);
  },
});

/**
 * Filter store for source filter (e.g., ?source=royalroad)
 */
export const sourceFilterSignal = createUrlFilterStore<string | null>({
  param: "source",
  defaultValue: null,
});
